import {
  InvestcoreBankDetailPage,
  InvestcoreBankEditPage,
  InvestcoreBankListPage,
} from 'apps/catalog/components/banks/pages';
import {
  ETFProductDetailPage,
  ETFProductEditPage,
  ETFProductListPage,
  ETFProfileEditPage,
} from 'apps/catalog/components/ETFProduct/pages';
import {
  InvestmentFundDistributorsDetailPage,
  InvestmentFundDistributorsListPage,
} from 'apps/catalog/components/fund-distributors/pages';
import {
  FundManagersCreatePage,
  FundManagersDetailPage,
  FundManagersEditPage,
  FundManagersListPage,
} from 'apps/catalog/components/fund-managers/pages';
import {
  InvestmentProductDetailPage,
  InvestmentProductEditPage,
  InvestmentProductListPage,
} from 'apps/catalog/components/fund-products/pages';
import {
  MarketCalendarCreatePage,
  MarketCalendarDetailPage,
  MarketCalendarEditPage,
  MarketCalendarListPage,
} from 'apps/catalog/components/market-calendar/pages';
import {
  MarketIndexCreatePage,
  MarketIndexDetailPage,
  MarketIndexEditPage,
  MarketIndexListPage,
} from 'apps/catalog/components/market-indexes/pages';
import {
  StockEventDetailPage,
  StockEventEditPage,
  StockEventListPage,
} from 'apps/catalog/components/stock-events/pages';
import {
  ICBIndustryCreatePage,
  ICBIndustryDetailPage,
  ICBIndustryEditPage,
  ICBIndustryListPage,
  ICBSectorCreatePage,
  ICBSectorDetailPage,
  ICBSectorEditPage,
  ICBSectorListPage,
  ICBSubSectorCreatePage,
  ICBSubSectorDetailPage,
  ICBSubSectorEditPage,
  ICBSubSectorListPage,
  ICBSuperSectorCreatePage,
  ICBSuperSectorDetailPage,
  ICBSuperSectorEditPage,
  ICBSuperSectorListPage,
} from 'apps/catalog/components/stock-icb/pages';
import {
  StockFundamentalDetailPage,
  StockFundamentalListPage,
} from 'apps/catalog/components/StockFundamental/pages';
import {
  StockProductDetailPage,
  StockProductEditPage,
  StockProductListPage,
} from 'apps/catalog/components/StockProduct/pages';
import { Navigate, useLocation } from 'react-router-dom';

// These pages used to live under /admin/... (and /investcore/..., which
// already redirects to /admin/...). Send old links to the same page under
// /catalog, keeping the query string.
const LegacyAdminRedirect = () => {
  const { pathname, search } = useLocation();
  return (
    <Navigate to={pathname.replace(/^\/admin/, '/catalog') + search} replace />
  );
};

const MOVED_FROM_ADMIN = [
  'banks',
  'products',
  'stock-fundamentals',
  'fund-distributors',
  'fund-managers',
  'market-calendar',
  'market-index',
  'stock-events',
  'stock-icb',
];

const catalogRoutes = [
  // Investment Data
  { path: '/catalog/banks', element: <InvestcoreBankListPage /> },
  { path: '/catalog/banks/:id', element: <InvestcoreBankDetailPage /> },
  { path: '/catalog/banks/:id/edit', element: <InvestcoreBankEditPage /> },
  {
    path: '/catalog/products',
    element: <Navigate to="/catalog/products/funds" />,
  },
  { path: '/catalog/products/funds', element: <InvestmentProductListPage /> },
  {
    path: '/catalog/products/funds/:id',
    element: <InvestmentProductDetailPage />,
  },
  {
    path: '/catalog/products/funds/:id/edit',
    element: <InvestmentProductEditPage />,
  },
  { path: '/catalog/products/etfs', element: <ETFProductListPage /> },
  { path: '/catalog/products/etfs/:id', element: <ETFProductDetailPage /> },
  {
    path: '/catalog/products/etfs/:id/edit',
    element: <ETFProductEditPage />,
  },
  {
    path: '/catalog/products/etfs/:id/edit-profile',
    element: <ETFProfileEditPage />,
  },
  { path: '/catalog/products/stocks', element: <StockProductListPage /> },
  {
    path: '/catalog/products/stocks/:id',
    element: <StockProductDetailPage />,
  },
  {
    path: '/catalog/products/stocks/:id/edit',
    element: <StockProductEditPage />,
  },
  {
    path: '/catalog/stock-fundamentals',
    element: <StockFundamentalListPage />,
  },
  {
    path: '/catalog/stock-fundamentals/:id',
    element: <StockFundamentalDetailPage />,
  },
  {
    path: '/catalog/fund-distributors',
    element: <InvestmentFundDistributorsListPage />,
  },
  {
    path: '/catalog/fund-distributors/:id',
    element: <InvestmentFundDistributorsDetailPage />,
  },
  { path: '/catalog/fund-managers', element: <FundManagersListPage /> },
  {
    path: '/catalog/fund-managers/create',
    element: <FundManagersCreatePage />,
  },
  { path: '/catalog/fund-managers/:id', element: <FundManagersDetailPage /> },
  {
    path: '/catalog/fund-managers/:id/edit',
    element: <FundManagersEditPage />,
  },
  { path: '/catalog/market-calendar', element: <MarketCalendarListPage /> },
  {
    path: '/catalog/market-calendar/create',
    element: <MarketCalendarCreatePage />,
  },
  {
    path: '/catalog/market-calendar/:id',
    element: <MarketCalendarDetailPage />,
  },
  {
    path: '/catalog/market-calendar/:id/edit',
    element: <MarketCalendarEditPage />,
  },
  { path: '/catalog/market-index', element: <MarketIndexListPage /> },
  {
    path: '/catalog/market-index/create',
    element: <MarketIndexCreatePage />,
  },
  { path: '/catalog/market-index/:id', element: <MarketIndexDetailPage /> },
  {
    path: '/catalog/market-index/:id/edit',
    element: <MarketIndexEditPage />,
  },
  { path: '/catalog/stock-events', element: <StockEventListPage /> },
  { path: '/catalog/stock-events/all', element: <StockEventListPage /> },
  { path: '/catalog/stock-events/:id', element: <StockEventDetailPage /> },
  {
    path: '/catalog/stock-events/:id/edit',
    element: <StockEventEditPage />,
  },

  // ICB Classification
  {
    path: '/catalog/stock-icb',
    element: <Navigate to="/catalog/stock-icb/industries" />,
  },
  { path: '/catalog/stock-icb/industries', element: <ICBIndustryListPage /> },
  {
    path: '/catalog/stock-icb/industries/create',
    element: <ICBIndustryCreatePage />,
  },
  {
    path: '/catalog/stock-icb/industries/:id',
    element: <ICBIndustryDetailPage />,
  },
  {
    path: '/catalog/stock-icb/industries/:id/edit',
    element: <ICBIndustryEditPage />,
  },
  {
    path: '/catalog/stock-icb/supersectors',
    element: <ICBSuperSectorListPage />,
  },
  {
    path: '/catalog/stock-icb/supersectors/create',
    element: <ICBSuperSectorCreatePage />,
  },
  {
    path: '/catalog/stock-icb/supersectors/:id',
    element: <ICBSuperSectorDetailPage />,
  },
  {
    path: '/catalog/stock-icb/supersectors/:id/edit',
    element: <ICBSuperSectorEditPage />,
  },
  { path: '/catalog/stock-icb/sectors', element: <ICBSectorListPage /> },
  {
    path: '/catalog/stock-icb/sectors/create',
    element: <ICBSectorCreatePage />,
  },
  {
    path: '/catalog/stock-icb/sectors/:id',
    element: <ICBSectorDetailPage />,
  },
  {
    path: '/catalog/stock-icb/sectors/:id/edit',
    element: <ICBSectorEditPage />,
  },
  {
    path: '/catalog/stock-icb/subsectors',
    element: <ICBSubSectorListPage />,
  },
  {
    path: '/catalog/stock-icb/subsectors/create',
    element: <ICBSubSectorCreatePage />,
  },
  {
    path: '/catalog/stock-icb/subsectors/:id',
    element: <ICBSubSectorDetailPage />,
  },
  {
    path: '/catalog/stock-icb/subsectors/:id/edit',
    element: <ICBSubSectorEditPage />,
  },

  // Legacy URLs
  ...MOVED_FROM_ADMIN.map(section => ({
    path: `/admin/${section}/*`,
    element: <LegacyAdminRedirect />,
  })),
];

export default catalogRoutes;
